var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFormueLogoIconColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 39 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.55981 61.7388H12.7916V12.5356L43.286 12.4624V2.60718H2.55981V61.7388Z",
    fill: "#182361"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8207 27.29H22.2573V37.1452H33.8207V27.29Z",
    fill: "#182361"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormueLogoIconColor);
export default __webpack_public_path__ + "static/media/formue-logo-icon-color.01e77eb9fc41b406d1206a5786671ee2.svg";
export { ForwardRef as ReactComponent };